export default __webpack_public_path__ + "static/media/opensea.28f93058.svg";